import vectorSearchLinks from './vectorSearchLinks';

export default vectorSearchLinks;
